"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const netinfo_1 = __importDefault(require("@react-native-community/netinfo"));
const native_1 = require("@react-navigation/native");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_config_1 = __importDefault(require("react-native-config"));
const react_native_splash_screen_1 = __importDefault(require("react-native-splash-screen"));
const react_redux_1 = require("react-redux");
const config_1 = require("../../web/firebase/config");
const slice_1 = __importDefault(require("../app-reduxs/app/slice"));
const actions_1 = __importDefault(require("../app-reduxs/listUserBlock/actions"));
const actions_2 = __importDefault(require("../app-reduxs/listUserFollow/actions"));
const actions_3 = __importDefault(require("../app-reduxs/listUserMute/actions"));
const actions_4 = require("../app-reduxs/loginFirebase/actions");
const components_1 = require("../components");
const constants_1 = __importDefault(require("../constants/constants"));
const useApp_1 = __importDefault(require("../hooks/useApp"));
const AsyncStorage_1 = __importDefault(require("../utils/AsyncStorage"));
const DeeplinkHelper_1 = require("../utils/DeeplinkHelper");
const syncStorage_1 = require("../utils/syncStorage");
const MainNavigator_1 = __importDefault(require("./MainNavigator"));
const Routes_1 = __importDefault(require("./Routes"));
const rootNavigation_1 = __importStar(require("./rootNavigation"));
const AppContainer = () => {
    const { initAppData } = (0, useApp_1.default)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const refTimeout = (0, react_1.useRef)();
    const shouldReloadApp = (0, react_1.useRef)(false);
    const refreshTokenTimestamp = (0, react_1.useRef)(Date.now());
    const userAuthFirebase = (0, react_redux_1.useSelector)((state) => state.loginFirebaseReducer.user, react_redux_1.shallowEqual);
    const dataUser = (0, react_redux_1.useSelector)((state) => state?.loginReducer?.dataProfile, react_redux_1.shallowEqual);
    const accessToken = (0, react_redux_1.useSelector)((state) => state.loginReducer.accessToken);
    (0, react_1.useEffect)(() => {
        initAppData();
        (0, syncStorage_1.asyncStorageGetItem)(constants_1.default.ACCESS_TOKEN_LOCAL)
            .then(val => {
            shouldReloadApp.current = !val;
        })
            .catch((_err) => { });
        const connectionListener = netinfo_1.default.addEventListener(state => {
            if (!state.isConnected) {
                dispatch(slice_1.default.actions.updateConnectionStatus(false));
            }
        });
        // const listener = firebase.auth().onIdTokenChanged(async (user: any) => {
        // const expirationTime = user?.multiFactor.user.stsTokenManager.expirationTime;
        // if (expirationTime && moment().isAfter(moment(expirationTime))) {
        // 	await AsyncStorage.remove(constants.FIREBASE_TOKEN)
        // 	dispatch(refreshFirebaseAuth())
        // }
        // })
        const REFRESH_TOKEN_DISTANCE = 60 * 60 * 1000 - 5 * 60 * 1000;
        const appStateListener = react_native_1.AppState.addEventListener('change', (state) => {
            if (state === 'active') {
                const timeDistance = Date.now() - refreshTokenTimestamp.current;
                if (timeDistance >= REFRESH_TOKEN_DISTANCE) {
                    clearTimeout(refTimeout.current);
                    refreshFirebaseToken();
                }
            }
        });
        const listener = config_1.firebase.auth().onIdTokenChanged((user) => {
            if (user) {
                clearTimeout(refTimeout.current);
                refTimeout.current = setTimeout(refreshFirebaseToken, REFRESH_TOKEN_DISTANCE); // 1 minute before token expired
            }
        });
        react_native_1.Platform.OS !== 'web' && react_native_splash_screen_1.default.hide();
        return () => {
            connectionListener();
            listener();
            appStateListener.remove();
            clearTimeout(refTimeout.current);
        };
    }, []);
    (0, react_1.useLayoutEffect)(() => {
        if (userAuthFirebase) {
            if (react_native_1.Platform.OS === 'web' && dataUser) {
                const { firebase } = require('../../web/firebase/config');
                const ListUser = firebase
                    .firestore()
                    .collection('users')
                    .doc(dataUser?.user_id?.toString());
                const followSubscribe = ListUser.collection('followUsers').onSnapshot((snapshot) => {
                    let dataFollow = [];
                    snapshot.forEach(async (documentSnapshot) => {
                        dataFollow.push(documentSnapshot.id);
                    });
                    dispatch(actions_2.default.listFollowSuccessAction(dataFollow));
                });
                const blockSubscribe = ListUser.collection('blockUsers').onSnapshot((snapshot) => {
                    let dataBlock = [];
                    snapshot.forEach(async (documentSnapshot) => {
                        dataBlock.push(documentSnapshot.id);
                    });
                    dispatch(actions_1.default.listBlockSuccessAction(dataBlock));
                });
                const muteSubscribe = ListUser.collection('muteUsers').onSnapshot((snapshot) => {
                    let dataMute = [];
                    snapshot.forEach(async (documentSnapshot) => {
                        dataMute.push(documentSnapshot.id);
                    });
                    dispatch(actions_3.default.listMuteSuccessAction(dataMute));
                });
                return () => {
                    followSubscribe();
                    blockSubscribe();
                    muteSubscribe();
                };
            }
        }
    }, [userAuthFirebase, dataUser?.user_id]);
    (0, react_1.useEffect)(() => {
        if (accessToken && shouldReloadApp.current) {
            shouldReloadApp.current = false;
            const routeName = rootNavigation_1.default.navigationRef.current?.getCurrentRoute()?.name;
            let params = rootNavigation_1.default.navigationRef.current?.getCurrentRoute()?.params || {};
            if (routeName === Routes_1.default.HOME_ARTICLE_DETAIL) {
                params = { ...params, first: true };
            }
            if (routeName) {
                (0, rootNavigation_1.reset)({ index: 0, routeName, params });
            }
        }
    }, [accessToken]);
    const refreshFirebaseToken = async () => {
        refreshTokenTimestamp.current = Date.now();
        await AsyncStorage_1.default.remove(constants_1.default.FIREBASE_TOKEN);
        dispatch((0, actions_4.refreshFirebaseAuth)());
    };
    const linking = {
        prefixes: [],
        config: DeeplinkHelper_1.deepLinkConfigure,
    };
    const appName = react_native_1.Platform.OS == 'web' ? process.env.APP_NAME : react_native_config_1.default.APP_NAME;
    return (react_1.default.createElement(native_1.NavigationContainer, { ref: rootNavigation_1.default.navigationRef, linking: linking, documentTitle: {
            formatter: (_options, _route) => appName,
        }, onUnhandledAction: ({ type }) => {
            if (type === 'GO_BACK') {
                (0, rootNavigation_1.replace)(Routes_1.default.MAINTABBAR);
            }
        } },
        react_1.default.createElement(MainNavigator_1.default, null),
        react_1.default.createElement(components_1.CustomToast, null),
        react_1.default.createElement(components_1.ModalWelcome, null),
        react_1.default.createElement(components_1.ModalMaintain, null)));
};
exports.default = AppContainer;
